<div 
  class="modal-backdrop" 
  *ngIf="isOpen"
  (click)="onBackdropClick($event)"
  (keydown)="onEscapeKey($event)"
  tabindex="-1">
  
  <div class="modal-dialog" [ngClass]="['modal-' + size, hideScrollbar ? 'modal-hide-scrollbar' : '']">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header" *ngIf="title || closable">
        <h4 class="modal-title">{{ title }}</h4>
        <button 
          *ngIf="closable"
          type="button" 
          class="modal-close" 
          (click)="onClose()"
          aria-label="Close">
          ×
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body" [class.modal-hide-scrollbar]="hideScrollbar">
        <ng-content></ng-content>
      </div>

      <!-- Footer -->
      <div class="modal-footer" *ngIf="closable">
        <ng-content select="[slot=footer]"></ng-content>
      </div>
    </div>
  </div>
</div>
